import { useAuth } from "@agentech/auth-client";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  AdminGuard,
  AdminLayout,
  AdminProvider,
  AuditLogsPage,
  CreateOrganizationPage,
  DashboardPage,
  ImpersonationBanner,
  OrganizationDetailsPage,
  OrganizationsPage,
  UserDetailsPage,
  UsersPage,
} from "./admin";
import { AuthStatusScreen } from "./components/AuthStatusScreen";
import { CallbackPage } from "./pages/CallbackPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { LogoutPage } from "./pages/LogoutPage";

export function App() {
  const { isAuthenticated, isInitializing } = useAuth();

  if (isInitializing) {
    return (
      <AuthStatusScreen>
        <div className="loading-spinner" />
        <p>Loading...</p>
      </AuthStatusScreen>
    );
  }

  return (
    <AdminProvider>
      <ImpersonationBanner />
      <Routes>
        <Route path="/callback" element={<CallbackPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* Admin routes */}
        <Route
          path="/admin"
          element={
            <AdminGuard>
              <AdminLayout />
            </AdminGuard>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="organizations" element={<OrganizationsPage />} />
          <Route path="organizations/new" element={<CreateOrganizationPage />} />
          <Route path="organizations/:id" element={<OrganizationDetailsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailsPage />} />
          <Route path="audit" element={<AuditLogsPage />} />
        </Route>

        <Route path="/" element={isAuthenticated ? <RedirectToApp /> : <LoginPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AdminProvider>
  );
}

function RedirectToApp() {
  const returnTo = sessionStorage.getItem("auth_return_to");

  if (returnTo) {
    sessionStorage.removeItem("auth_return_to");
    window.location.href = returnTo;
    return (
      <AuthStatusScreen>
        <div className="success-icon">&#10003;</div>
        <p>Redirecting...</p>
      </AuthStatusScreen>
    );
  }

  // Default redirect to platform subdomain based on current environment
  const hostname = window.location.hostname;
  let platformUrl = "https://platform.agentech.com";

  if (hostname.includes(".agentech.local") || hostname === "agentech.local") {
    // Local development via Caddy reverse proxy
    platformUrl = "https://platform.agentech.local";
  } else if (hostname.includes("agentech-dev")) {
    platformUrl = "https://platform.agentech-dev.com";
  } else if (hostname.includes("agentech-stage")) {
    platformUrl = "https://platform.agentech-stage.com";
  } else if (hostname === "localhost") {
    platformUrl = "http://localhost:3000";
  }

  window.location.href = platformUrl;

  return (
    <AuthStatusScreen>
      <div className="success-icon">&#10003;</div>
      <p>Redirecting to platform...</p>
    </AuthStatusScreen>
  );
}
